import React from 'react';

const Admin = (props) => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/admin b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-386.000000, -1181.000000)" fill="#000000">
                <g id="Icon/Navigation/Category/24-Copy" transform="translate(386.000000, 1181.000000)">
                    <path
                        d="M12,1.5 C14.8994949,1.5 17.25,3.85050506 17.25,6.75 C17.25,8.23674102 16.6320019,9.57914086 15.6388774,10.5343279 C18.6520624,10.852396 21,13.4020029 21,16.5 L21,22.5 L3,22.5 L3,16.5 C3,13.4020029 5.34793761,10.852396 8.36140998,10.5335821 C7.36799809,9.57914086 6.75,8.23674102 6.75,6.75 C6.75,3.85050506 9.10050506,1.5 12,1.5 Z M15,12 L9,12 C6.58572667,12 4.61551091,13.9012365 4.50489799,16.2881643 L4.5,16.5 L4.5,21 L19.5,21 L19.5,16.5 C19.5,14.0857267 17.5987635,12.1155109 15.2118357,12.004898 L15,12 Z M12,3 C9.92893219,3 8.25,4.67893219 8.25,6.75 C8.25,8.82106781 9.92893219,10.5 12,10.5 C14.0710678,10.5 15.75,8.82106781 15.75,6.75 C15.75,4.67893219 14.0710678,3 12,3 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Admin;
